import { setupCalendar } from 'v-calendar';
import i18n from '@/i18n/i18n';

function set(language) {
  setupCalendar({
    paneWidth: 240,
    firstDayOfWeek: 2,
    locale: language,
  });
}

export default () => {
  set(i18n.defaultLanguage);
  i18n.addLocaleChangeListener(set);
};
